export default __webpack_public_path__ + "static/media/step2.123e6f64.png";